/*
 *  (c) 2015 - 2021 ENISCO by FORCAM GmbH
 */

import {Hardlink} from '../model/hardlinks'

export const enisco_homepage = {
  module: 'enisco',
  app: 'homepage',
  description: [
    {
      language: 'en',
      translation: 'Enisco Homepage'
    },
    {
      language: 'de',
      translation: 'Enisco Webseite'
    }
  ],
  icon: 'http://www.enisco.com/favicon.gif',
  url: 'http://www.enisco.com'
}
export const enisco_server = {
  module: 'enisco',
  app: 'server',
  description: [
    {
      language: 'en',
      translation: 'Enisco Server'
    },
    {
      language: 'de',
      translation: 'Enisco Server'
    }
  ],
  url: 'https://ensrd111.enisco.corp/'
}

const enisco_module = {
  name: 'enisco',
  description: [
    {
      language: 'en',
      translation: 'ENisco Module'
    },
    {
      language: 'de',
      translation: 'ENisco Modul'
    }
  ],
  icon: 'http://www.enisco.com/favicon.gif',
  apps: [enisco_homepage, enisco_server]
}

export const hardlink: Hardlink = {
  id: '12345',
  module: 'enisco',
  app: 'homepage',
  parameters: {}
}

export const modules = {
  modules: [enisco_module],
  apps: [enisco_homepage, enisco_server]
}
export const apps = {apps: [enisco_homepage, enisco_server]}
